// extracted by mini-css-extract-plugin
export default {"menu":"CellContextMenu_menu__O76NP","item":"CellContextMenu_item__tj4nY","itemDanger":"CellContextMenu_itemDanger__+BL5s","divider":"CellContextMenu_divider__hSdlb"};